import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { StockPublicationSliceState } from "../../types";
import { addCleanSettingsExtraReducers } from "./cleanSettings";
import { addFetchSettingsExtraReducers } from "./fetchSettings";
import { addSaveSettingsExtraReducers } from "./saveSettings";

export const registerStockPublicationExtraReducers = (
  builder: ActionReducerMapBuilder<StockPublicationSliceState>,
) => {
  addFetchSettingsExtraReducers(builder);
  addSaveSettingsExtraReducers(builder);
  addCleanSettingsExtraReducers(builder);
};
